import axios from 'axios'
import { get, post, del,getfile } from '@/http/request'
import { HOST } from '@/http/config'

// 基础信息管理车辆信息
export function getVehiclelist(params) {
  return get(`${HOST}basis-vehicle/list`, params)
}
// 根据id删除
export function delVehiclelist(params) {
  return del(`${HOST}basis-vehicle/delete`, params)
}
// 详情
export function vehiclelistDetails(params) {
  return get(`${HOST}basis-vehicle/get`, params)
}
// 新增
export function saveVehiclel(params) {
  return post(`${HOST}basis-vehicle/save`, params)
}
// 修改
export function updateVehiclel(params) {
  return post(`${HOST}basis-vehicle/update`, params)
}
//历史修改版本列表
export function getHistoryList(params) {
  return get(`${HOST}basis-vehicle-history/list`, params)
}
// 历史修改版本详情
export function getHistoryDetial(params) {
  return get(`${HOST}basis-vehicle-history/get`, params)
}
// 导出
export function Export(params) {
  return getfile(`${HOST}basis-vehicle/export`, params)
}



// WEBPACK FOOTER //
// ./src/views/baseInfoManagement/vehicleInfo/api.js